<div class="prize-selection">
  <div class="prize-selection-title">{{ 'prize.selection.title' | translate }}</div>
  <div class="prize-selection-prizes" *ngFor="let prize of prizes">
    <div
      class="prize-selection-prize"
      (click)="onPrizeSelected(prize)"
      [ngClass]="{ 'prize-disabled': prize?.SoldOut, 'prize-selected': prizeSelectedCondition(prize) }"
    >
      <ng-container *ngIf="showPrizeIcon">
        <div class="material-icons">{{ prizeIcon(prize.PrizeType) }}</div>
      </ng-container>
      <div class="prize-title">{{ prize.PrizeTitle }}</div>
    </div>
    <div *ngIf="prize?.SoldOut" class="prize-sold-out">{{ 'prize.selection.sold.out' | translate }}</div>
  </div>
  <button [disabled]="!prizeSelected" class="btn prize-selection-btn-confirm" (click)="onPrizeConfirm()">
    {{ 'prize.selection.confirm' | translate }}
  </button>
</div>
